'use strict';

import ajax from '../../ajax';
import image from './image';
import progress from '../../progress';
import productStoreInventory from '../../storeinventory/product';
import socialShareIcons from './socialShareIcons';
import recommendations from './recommendations';
import util from '../../util';
import variationfilter from './variationfilter';
import { initFindation } from './findationHelper';
import analytics from '../../analytics';
import customDropdown from '../../custom-dropdown';
import miniCrossSell from "./../../mini-crosssell";
import reassurance from '../../reassurance';
import copyTextClipboard from '../../copy-text-clipboard';
import validator from '../../validator';
import {dialogSDK} from './dialogSDK';

let stickySidebar,
    timerSwatchHover,
    timerSwatchHoverOut,
    timerSwatchHoverPid;

const heightOfImage = $(".product-primary-image").height();
const heightOfImageInner = $(".slider-main-image").height();

function updateMiniQuickViewContent(href, target) {
    var $pdpForm = $('.pdpForm');
    var qty = $pdpForm.find('select[name="Quantity"] option:selected').val();
    var targetContainer = target ? target : '#product-content';
    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
    };

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $(targetContainer),
        callback: function () {
            if (SitePreferences.STORE_PICKUP) {
                productStoreInventory.init();
            }
            //Commenting below line will prevent "eeProductDetail" event to fire on variation change
            //$(document).trigger("gtvariationchange");
            setCategoryItem();
            regimenVariationfilter();   
            var selectedColor = $('.variation-select').find(':selected').data('color');
            $('.swatch-block.selected_color').attr('style',selectedColor);
            $('.variation-filters select').trigger( "change" );
        }
    });
}

function reinsuranceContent() {
    let maxHeight = 0;
    $('.reinsurance-wrapper').each(function () {
        let titleHeight = $(this).find('.reinsurance-content .reinsurance-title').outerHeight();
        maxHeight = Math.max(maxHeight, titleHeight); // Keep track of the max height
    });
    $('.reinsurance-wrapper').each(function() {
        $(this).find('.reinsurance-content').css({
            'height': maxHeight + 48 + 'px',
            'min-height': maxHeight + 48 + 'px'
        });
    });
}

// Sticky Scroll Image container
if ($('.pt_product-details .pdp-main .product-image-container').length) {
    let topSpacingImage = $(".pdp-redesign-enabled").length ? 133 : 130;
    topSpacingImage = $(".marketing-banner").length ? topSpacingImage + 36 : topSpacingImage;

	stickySidebar = new StickySidebar('.product-image-container', {
		topSpacing: topSpacingImage,
		bottomSpacing: 130,
		resizeSensor: true,
		innerWrapperSelector: '.sidebar__inner'
	});
    displayPDPImage();

}

function resizeStickySidebar() {
		if ($(window).width() < 991 && $('.pt_product-details .pdp-main .product-image-container').length && !$('.cart-body').length > 0) {
			stickySidebar.destroy();
		}
}

function updateContent(href,guid,callback) {
    var $pdpForm = $('.pdpForm');
    var qty = $pdpForm.find('select[name="Quantity"] option:selected').val();

    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        PDPRedEnableFlag: $(".pdp-redesign-enabled").length > 0 ? true : false,
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
    };

    var $sliderMainImage = $('.slider-main-image');
    if($sliderMainImage.hasClass("slick-initialized")) {
        $sliderMainImage.slick('unslick');
    }
    $sliderMainImage.html("");

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $('#product-content'),
        callback: function () {
            if (SitePreferences.STORE_PICKUP) {
                productStoreInventory.init();
            }
            
            var $productPrimaryImage = $(".product-primary-image").find(".slide").eq(0);
    		var colorway = $productPrimaryImage.find("[data-colorway]").attr('data-colorway');
    		if(colorway) {
    			$('body').removeClass("colorway-solid-white colorway-solid-black colorway-transparent-white colorway-transparent-black").addClass(colorway);  
    		}
    		
            //Uncommenting as Part of NAB-4942, below line will trigger "eeProductDetail" event to fire on variation change
            $(document).trigger("gtvariationchange");
            initFindation();
            socialShareIcons();
            setCategoryItem();
            regimenVariationfilter();
            $('.variation-filters select').trigger( "change" );
            setBVSummaryPosition();
            customDropdown.init();
            checkoutReinsurancePopup();
            initColorCategoryFilter();
            initColorShadesSlider();
            initMiniCrossSellPDP();
            initReassuranceCarousel();
            initShadeUndertoneFilters();
            addMinHeightToPdpImage();
            reinsuranceContent();
            $(document).foundation();
            copyTextClipboard.init();
            notifyOnWhatsapp();
            hideOverflowingList();
            
            if(stickySidebar) {
                stickySidebar.destroy();
            }
            
            const $liveRegion = $('.price-live-region');
			if ($liveRegion.length) {
				const html = $liveRegion.html();
				$liveRegion.empty();
				setTimeout(function () {
					$liveRegion.html(html);
				}, 500);
			}

            // scroll to selected category
            var stickySidebar;
			var selectedVariant = $('#product-content .pdp-color-category-filter li.selected'); // get the selected variant
			var indexOfSelected = selectedVariant.closest('.slick-slide').attr('data-slick-index'); // know it's index
			var updatedIndex  = indexOfSelected > 1 ? indexOfSelected - 1 : indexOfSelected;
			indexOfSelected > 1 && $('#product-content .pdp-color-category-filter').slick('slickGoTo', updatedIndex, false);
            let topSpacingImage = $(".pdp-redesign-enabled").length ? "100" : "130";
			setTimeout(() => {
				if ($(window).width() >= 991 && $('.pt_product-details .pdp-main .product-image-container').length) {
                    stickySidebar = new StickySidebar('.pt_product-details .pdp-main .product-image-container', {
						topSpacing: topSpacingImage,
						bottomSpacing: 130,
						resizeSensor: true,
						innerWrapperSelector: '.sidebar__inner'
					});
				}
                image();
                displayPDPImage();
			}, 2000);
            if(guid){
                variationChangeVTO(guid);
            }
            if (SitePreferences.DIALOG_SCRIPT_ENABLED) {
				dialogSDK.initPDP();
			}
            if (callback) {
				callback();
			}
        }
    });
}

function addMinHeightToPdpImage() {
    const windowWidth = $(window).width();
    if(windowWidth < 767) {
        $(".product-primary-image").css({
            "min-height": heightOfImage,
            "max-height": heightOfImage
        });
        $(".slider-main-image").css({
            "min-height": heightOfImageInner,
            "max-height": heightOfImageInner
        });
    }
}

function displayPDPImage() {
    $(".pdp-main .primary-image").css("display", "block");
    $(".slider-main-image").css({
        "min-height": heightOfImageInner,
        "max-height": heightOfImageInner
    });
    $(".pt_product-details .product-primary-image .matchmaker-cta-wrapper").css("display", "flex");
}

function updateContentRegimen(obj,href) {
	var result = JSON.parse(JSON.stringify(util.parseQueryString(href)));
	result.Quantity = '1';
	result.format = 'ajax';
	result.isregimenpropduct = true;
	var regimenTileContent = obj.parents('.product-tile-section').find('.content');
	result.content = regimenTileContent.length > 0 ? $.trim(regimenTileContent.text()) : "";

    ajax.load({
        url: util.appendParamsToUrl(Urls.transactionalHitTile, result),
        target: obj.closest(".regimen-product-column"),
        callback: function () {
        	window.app.productTile.init();
            $(document).trigger("gtvariationchange");          
            $('.variation-filters select').trigger( "change" );
            regimenVariationfilter();
            customDropdown.init();
            setTimeout(() => {
                $('.regimen-product-column').find('.custom-dd-list-item-selected .oos-label').length > 0 ? $(' .regimenzone.add-all').attr('disabled', 'disabled') : $('.regimenzone.add-all').removeAttr('disabled');
            }, 1000);
        }
    });
}

function formatPidDataFromEles($selector) {
    return $selector.toArray().map(function (ele) {
        var $qtyfield = $('.product-form-actions');
        var $ele = $(ele),
            pid = $ele.data('pid'),
            price = $ele.data('price'),
            listprice = $ele.data('listprice'),
            qty = $ele.find('select[name="Quantity"]').length ? $ele.find('select[name="Quantity"]').val() : $qtyfield.find('select[name="Quantity"]').val();
        return {
            pid: pid,
            standardPrice: Number(listprice * qty).toFixed(2),
            salePrice: Number(price * qty).toFixed(2)
        };
    });
}

function updateSetContent($ele, href, availability) {
    var $productSetItemCtnr = $ele.parents(".product-set-item"),
        qty = $productSetItemCtnr.find('form select[name="Quantity"]').val();

    $.get(util.appendParamsToUrl(href, {
        Quantity: isNaN(qty) ? '1' : qty,
        format: "ajax",
        setproduct: true
    })).done(function (html) {
        $productSetItemCtnr.html(html);
        updateProductSetPrices(availability);
    });
}

function setCategoryItem(){
    var threshold = 40;
    $('.variation-filters select').on('change', function (e) {
        var id  = $('.variation-filters select').attr('id').toLowerCase();
        var optionSelected = $("option:selected", this)[0].label;
        var $variants = $('.swatches li').not(".view-all");

        if(optionSelected[0].label !== 'ALL'){
            $variants = $variants.hide().filter('[data-'+ id+'='+optionSelected+']');
        }
        $variants.show().filter(":gt("+(threshold-1)+")").hide();
        $('.swatches li.view-all').toggleClass("hide", !($variants.length > threshold));
    });
    
    var $producttile = $('.product-tile');
    var $variants = $('.swatches li', $producttile).not(".view-all");
    $variants.show().filter(":gt("+(threshold-1)+")").hide();
    $('.swatches li.view-all', $producttile).toggleClass("hide", !($variants.length > threshold));

    //Redirect to PDP from QV - after changing shade
    setTimeout(function(){     	
	    var bvReviewURL = $(".quickview-modal .pdp-main .product-title>a").attr("href");
	    $(".quickview-modal .bv-write-review-container button").removeClass("bv-write-review");	    
	    $(".quickview-modal .bv-write-review-container button").on("click", function(e) {
	       e.preventDefault();
	       		window.setTimeout(function(){
	       			window.location.href = bvReviewURL+"#writeReview";  	       			
	       		}, 50);       		
	    	});  
	}, 1000);   
        
}

function regimenVariationfilter(selectedFilterValue) {
	var threshold = 40;
	var $variants_container = $(".regimenzone .product-variations .product-variation-swatch-lists #pdp-swatches");
	var $variants_filtered;
	if($variants_container.length) {
		$variants_container.each(function() {
			if(selectedFilterValue) {
				$variants_filtered = $(this).find("li:not(.view-all)").removeClass("swatch-item-extra").addClass('hide').filter("."+selectedFilterValue).removeClass('hide');
			} else {
				$variants_filtered = $(this).find("li:not(.view-all)").removeClass("swatch-item-extra hide");
			}	
            $variants_filtered.show().filter(":gt("+(threshold-1)+")").hide();
			$variants_filtered.filter(":gt("+(threshold-1)+")").addClass('swatch-item-extra');
			$(this).removeClass("expanded").find(".view-all").toggleClass("hide", $variants_filtered.length <= threshold);
		})
    }	
}

// to set BV summary alignment in the DOM 
function setBVSummaryPosition() {   
    var $BVContainer = ($(window).width() < 768) ? $(".pdp-main .product-info-mobile-only .bazaarvoice-summary-placeholder") : $(".pdp-main .product-info .bazaarvoice-summary-placeholder");
    var $BVElement = $(".pdp-main .bv-reviews-and-qna-wrapper");
    if($BVContainer.length && $BVElement.length) {
        $BVElement.css({"top": $BVContainer.position().top, "left": $BVContainer.position().left });
        $BVElement.removeClass("hidden");
    }
}

// function responsible to handle resize events
function screenResizeHandler() {
	// Store the window width
    var winWidth = $(window).width();
	$(window).on('resize orientationchange', function () {
		// to prevent calling of resize event while scrolling in IOS devices
        if ($(window).width() != winWidth) {
            // Update the window width for next time
            winWidth = $(window).width();            
			// Do stuff here
            setBVSummaryPosition();
            initColorShadesSlider();
            initMiniCrossSellPDP();
            initReassuranceCarousel();
        }
	});
}

//pop -up PDP ReinsurancePopup
function checkoutReinsurancePopup() {	
	$('a.cart-reinsuance-modal').on('click', function(e) {	
		e.preventDefault();
		e.stopImmediatePropagation();
		var $this = $(this);		
		analytics.reinsuranceElements($this.attr('id'));		
		
		$.ajax({
			url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
			method: 'GET'
		})
		.done(function (response) { 
			if (response) {
                modal.addCustomClass('checkout-reinsurance-inner-wrapper');
                modal.renderContent(response);
			}
		});
	});
}
// apply color on swatch change VTO
function variationChangeVTO(guid) {
    var isVTOUp = $('.vto-iframe-opened');
	if ((isVTOUp.length > 0) && guid && SitePreferences.YOU_CAM_ENABLED) {
        window.YMK.applyMakeupBySku(guid);
	}
}
// to set VTO iframe alignment
function setVTOIframePosition() {
    var $iframeContainer = $('.VTO-module'),
        $imageContainer = $('.pt_product-details .product-image-container'),
        $stickySidebar = $('.pt_product-details .product-image-container .sidebar__inner'),
        $iframePlaceholer = $('.pt_product-details .pdp-main .product-detail'),		
        windowWidth = $(window).width();
    if($iframeContainer.length && $iframePlaceholer.length && $imageContainer.length && $stickySidebar.length) {
        if(windowWidth > 767 && windowWidth <= 1024) {            
            if($imageContainer.hasClass('is-affixed') && $stickySidebar.css("position") === "fixed") {
                $iframeContainer.css({
                    "position":"fixed",
                    "top": $stickySidebar.position().top || 0,
                    "left": $stickySidebar.position().left || 0,
                    "margin-top": "52px",
                    "margin-left": "70px",
                    "padding-left": "0",
                });
            } else {
                $iframeContainer.css({
                    "position":"absolute",
                    "top": $stickySidebar.offset().top - $iframePlaceholer.offset().top || 0,
                    "left": 0,
                    "margin-top": "52px",
                    "margin-left": "70px",
                    "padding-left": "30px"
                });
            }
        } else if(windowWidth > 767 && windowWidth > 1024) {
            if($imageContainer.hasClass('is-affixed') && $stickySidebar.css("position") === "fixed") {
                $iframeContainer.css({
                    "position":"fixed",
                    "top": $stickySidebar.position().top || 0,
                    "left": $stickySidebar.position().left || 0,
                    "margin-top": "52px",
                    "margin-left": "150px",
                    "padding-left": "0",
                });
            } else {
                $iframeContainer.css({
                    "position":"absolute",
                    "top": $stickySidebar.offset().top - $iframePlaceholer.offset().top || 0,
                    "left": 0,
                    "margin-top": "52px",
                    "margin-left": "150px",
                    "padding-left": "50px"
                });
            }
        } else {
            // mobile view
            $iframeContainer.css({
                "position":"absolute",
                "top": $('#pdpMain .product-detail .product-info-mobile-only').height() || 0,
                "left": 0,
                "margin-top": 0,
                "margin-left": 0,
                "padding-left": 0
            });
        } 
    }
}
function asyncSetVtoIframePosition(ms) {
    var isLoaded = null;
    if(isLoaded){
        clearTimeout(isLoaded);
    }		
    isLoaded = setTimeout(function(){
        setVTOIframePosition();
    }, ms);
}

function notifyOnWhatsapp() {
    const $notifyWrapper = $('.notify-whatsapp-wrapper');
    if (!$notifyWrapper.length) { return; }

    // Cache all DOM elements
    const $btn = $notifyWrapper.find('.notify-whatsapp-button');
    const $inputWrapper = $notifyWrapper.find('.notify-whatsapp-header');
    const $input = $notifyWrapper.find('.notify-whatsapp-input');
    const $clearBtn = $notifyWrapper.find('.icon-close');
    const $notifySent = $notifyWrapper.find('.notify-whatsapp-sent');
    const $countryDropdown = $notifyWrapper.find('#country-dropdown');
    const $iconCheckmark = $notifyWrapper.find('.icon_checkmark');
    const $waxbackinstockForm = $notifyWrapper.find('form.whats_notification_form');
    
    let isValid = false;
    let currentCountry = '';
    let hasDisabledOption = false;

    // Cache validator and regex references
    const phoneRegex = validator.regex.phone || {};
    const defaultRegex = phoneRegex.other;
    const phoneExamples = validator.regex.phoneExampleByCountry || {};

    const setPhoneExampleForCountry = (country) => {
        const example = phoneExamples[country] || '';
        $input.attr('placeholder', example).val('').removeClass('valid invalid');
        isValid = false;
        $input.trigger('change');
    };

    const disableInputField = () => {
        $input.prop('disabled', true).attr('placeholder', '');
        $clearBtn.addClass('hide');
        hasDisabledOption = true;
    };

    const enableInputField = (countryCode, country) => {
        $input.prop('disabled', false);
        $clearBtn.removeClass('hide');
        currentCountry = country;
    };

    const clearError = () => {
        const $errorSpan = $input.next('.error');
        if ($errorSpan.length) {
            $errorSpan.remove();
        }
    };

    const showError = () => {
        let $errorSpan = $input.next('.error');
        if (!$errorSpan.length) {
            $input.after(`<span class="error hide">${$input.attr('data-required-text')}</span>`);
            $errorSpan = $input.next('.error');
        }
        $errorSpan.removeClass('hide');
    };

    const updateValidationUI = (isInputValid) => {
        $btn.toggleClass('disabled', !isInputValid);
        $input.toggleClass('valid', isInputValid).toggleClass('invalid', !isInputValid);
        $clearBtn.toggleClass('hide', isInputValid);
        $iconCheckmark.toggleClass('hide', !isInputValid);
    };

    // Initialize on page load
    const $disabledOption = $countryDropdown.find('option:disabled');
    if ($disabledOption.length && $disabledOption.val() === '') {
        disableInputField();
    } else {
        const $selectedOption = $countryDropdown.find('option:selected');
        enableInputField($selectedOption.data('area-code'), $selectedOption.val().toLowerCase());
        setPhoneExampleForCountry(currentCountry);
    }

    // Country dropdown change handler
    $countryDropdown.on('change', function() {
        const $selectedOption = $(this).find('option:selected');
        const selectedCountry = $selectedOption.val().toLowerCase();
        const countryCode = $selectedOption.data('area-code');
        
        enableInputField(countryCode, selectedCountry);
        clearError();
        setPhoneExampleForCountry(selectedCountry);
    });

    // Phone input validation handler
    $input.on('keyup change', function() {
        const inputVal = $(this).val();
        const phoneRegexForCountry = phoneRegex[currentCountry] || defaultRegex;
        isValid = phoneRegexForCountry && phoneRegexForCountry.test(inputVal);

        // Update UI state
        $btn.toggleClass('disabled', inputVal === '');
        updateValidationUI(isValid && inputVal !== '');

        if (!isValid && inputVal !== '') {
            showError();
        } else {
            clearError();
        }
    });

    // Button click handler
    $btn.on('click', function() {
        if ($inputWrapper.hasClass('hide')) {
            $inputWrapper.removeClass('hide');
            $btn.addClass('disabled');
        } else if (isValid) {
            const selectedCountryCode = $countryDropdown.find('option:selected').val().toLowerCase();
            let customerFoneNumber = $input.val();
            if (selectedCountryCode && customerFoneNumber) {
                customerFoneNumber = util.getFormattedPhoneNumber(customerFoneNumber,selectedCountryCode);
                // Submit form via AJAX if phone number is valid
                $.ajax({
                    url: $waxbackinstockForm.attr('action'),
                    data: $waxbackinstockForm.serialize()+ '&customerFoneNumber='+encodeURIComponent(customerFoneNumber),
                    method: 'POST',
                    success: function(response) {
                        if (response.success) {
                            $inputWrapper.addClass('hide');
                            $btn.addClass('disabled');
                            $notifySent.removeClass('hide');
                        }
                    },
                    error: function() {
                        // Handle error scenario
                    }
                });
            }
        } else {
            showError();
        }
    });

    // Clear button handler
    $clearBtn.on('click', function() {
        $input.val('');
        $btn.addClass('disabled');
        clearError();
    });
}

/**
 * Callback function to check availability after content update
 */
function checkAvailability() {
    let notAvailable = false;

    $('#product-set input[name="availability"]').each(function () {
        if ($(this).val() === 'NOT_AVAILABLE') {
            notAvailable = true;
            return false;
        }
    });

    $('#add-all-to-cart').prop("disabled", notAvailable);
}

function initColorCatFiltersEvents() {
    $(document).on('click keydown', '.color-filter-attr', function (e) {

        if (e.type === 'keydown' && e.key !== 'Enter') return;
        e.preventDefault();
        const $container = $(this).closest('.pdp-vars');
        const selectedValue = $(this).text().trim();
        const selectedColor = $(this).data('color');
        handleColorSwatches($container, selectedValue, selectedColor);
        if(!window.checkCountClicked) {
            window.dataLayer.push(util.filterObj({
                "event": "productInteraction",
                "productName": getProductNameWithoutSpace(),
                "productId": $('#pid').val(),
                "interactionType": "select_category_shade"
            }));
        } else {
            window.checkCountClicked = false;
        }
    });

    $(document).on('click keydown', '.product-shade-panel .color-filter-attr', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }
        e.stopPropagation();
        const selectedValue = $(this).text().trim();
        const $shadePanelList = $('.product-shade-panel .custom-dd-list-item');
        const countOfShadesWithSelectedColorCat = $shadePanelList.filter(function () {
            const curVal = $(this).data('ccatvalues') || '';
            const curValArr = curVal.split(', ');
            return curVal && curValArr.includes(selectedValue);
        }).length;
        const selectedColor = $(this).data('color');

        $('.product-shade-panel').find('.shade-count').text(countOfShadesWithSelectedColorCat);
        $('.product-shade-panel .color-filter-attr').removeClass('selected').attr('aria-pressed', 'false').each(function () {
            const $this = $(this);
            $this.attr('aria-label', $this.text().trim() + ', ' + $this.data('not-selected-label'));
        });
        $('.product-shade-panel .color-filter-attr[data-color="' + selectedColor + '"]').addClass('selected').attr('aria-pressed', 'true').each(function () {
            const $this = $(this);
            $this.attr('aria-label', $this.text().trim() + ', ' + $this.data('selected-label'));
        });

        $shadePanelList.filter(function () {
            const $this = $(this);
            const curVal = $this.data('ccatvalues') || '';
            const curValArr = curVal.split(', ');
            if (curVal && curValArr.includes(selectedValue)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        if (e.type === 'keydown') {
            $shadePanelList.removeClass('productshadelastelement');
            $shadePanelList.filter(':visible').last().addClass('productshadelastelement');
        }
    });
}

// updates +N text and aria-label so screen readers announce the current remaining count
function updateRemainingCount($remaining, hiddenCount) {
    if (!$remaining.length) return;

    if (hiddenCount > 0) {
        const labelTemplate = $remaining.data('remaining-label');
        $remaining.removeClass('hide').text(`+${hiddenCount}`);
        if (labelTemplate) {
            $remaining.attr('aria-label', labelTemplate.replace('{0}', hiddenCount));
        }
    } else {
        $remaining.addClass('hide').removeAttr('aria-label');
    }
}

function handleColorSwatches($container, selectedValue, selectedColor) {
    const $filters = $container.find('.color-filter-attr');
    const $swatchesWrapper = $container.find('#pdp-swatches.swatches.color');
    const $swatches = $swatchesWrapper.find('li').not('.remaining-count');
    const defaultValue = $filters.filter('.default').first().text().trim();

    if (!$swatchesWrapper.length) return;

    /* ---------------------------
       1. Update Selected Filter UI
    --------------------------- */
    $filters.removeClass('selected').attr('aria-pressed', 'false').each(function () {
        $(this).attr('aria-label', $(this).text().trim() + ', ' + $(this).data('not-selected-label'));
    });
    $filters.filter(`[data-color="${selectedColor}"]`).addClass('selected').attr('aria-pressed', 'true').each(function () {
        $(this).attr('aria-label', $(this).text().trim() + ', ' + $(this).data('selected-label'));
    });

    localStorage.setItem('selColorCat', selectedValue);
    /* ---------------------------
       2. Filter Swatches (business logic)
    --------------------------- */
    $swatches.each(function () {
        const $li = $(this);
        const curVal = $li.data('ccatvalues') || '';
        const curValArr = curVal.split(', ');

        if (!selectedValue || selectedValue === defaultValue || curValArr.includes(selectedValue)) {
            $li.show().removeClass('inActive');
        } else {
            $li.hide().addClass('inActive');
        }
    });

    /* ---------------------------
       3. Auto-select first visible swatch
    --------------------------- */
    const $visibleSwatches = $swatches.filter(':visible');

    if ($visibleSwatches.length && !$visibleSwatches.hasClass('selected')) {
        let $first;

        if ($visibleSwatches.hasClass('selectable')) {
            $first = $swatchesWrapper.find('li.selectable:visible').first();
        } else {
            $first = $visibleSwatches.first();
        }
        window.checkCategoryClicked = true;
        $first.find('.swatchanchor').trigger('click');
    }

    /* ---------------------------
       4. Overflow Handling
    --------------------------- */
    if(!$('.pt_product-details').length) return;
    
    // Reset hidden state first
    $swatches.removeClass('hide');

    const wrapperRight = $swatchesWrapper[0].getBoundingClientRect().right;

    // Consider only visible (filtered) swatches
    const $activeSwatches = $swatches.filter(':visible');

    let firstOverflowIndex = -1;

    $activeSwatches.each(function (index) {
        const liRight = this.getBoundingClientRect().right;

        if (liRight > wrapperRight) {
            firstOverflowIndex = index;
            return false;
        }
    });

    if (firstOverflowIndex > 0) {
        $activeSwatches.each(function (index) {
            const $li = $(this);

            if ($li.hasClass('selected')) {
                $li.removeClass('hide');
                return;
            }

            if (index >= firstOverflowIndex - 2) {
                $li.addClass('hide').hide();
            }
        });
    }

    /* ---------------------------
       5. Remaining Count (+X)
    --------------------------- */
    const hiddenCount = $activeSwatches
        .filter(':not(.view-all)')
        .filter('.hide')
        .not('.selected')
        .length;

    const $remaining = $swatchesWrapper.find('li.remaining-count');

    if ($remaining.length) {
        if (hiddenCount > 0) {
            $remaining.removeClass('hide').text(`+${hiddenCount}`);
        } else {
            $remaining.addClass('hide');
        }
    }
}

function autoSelectFirstVisibleSwatch($swatchesWrapper, $swatches) {
    if (!$swatchesWrapper.length) return;

    const $visibleSwatches = $swatches.filter(':visible');
    if (!$visibleSwatches.length || $visibleSwatches.hasClass('selected')) return;

    let $first = $visibleSwatches.first();
    if ($visibleSwatches.hasClass('selectable')) {
        $first = $swatchesWrapper.find('li.selectable:visible').first();
    }
}

function applySwatchOverflow($swatchesWrapper, $swatches) {
    if (!$('.pt_product-details').length || !$swatchesWrapper.length) return;

    const $activeSwatches = $swatches.filter(':visible');
    $activeSwatches.removeClass('hide');

    const wrapperRight = $swatchesWrapper[0].getBoundingClientRect().right;
    let firstOverflowIndex = -1;

    $activeSwatches.each(function (index) {
        const liRight = this.getBoundingClientRect().right;
        if (liRight > wrapperRight) {
            firstOverflowIndex = index;
            return false;
        }
    });

    if (firstOverflowIndex > 0) {
        $activeSwatches.each(function (index) {
            const $li = $(this);
            if ($li.hasClass('selected')) {
                $li.removeClass('hide');
                return;
            }
            if (index >= firstOverflowIndex - 2) {
                $li.addClass('hide').hide();
            }
        });
    }

    const hiddenCount = $activeSwatches
        .filter(':not(.view-all)')
        .filter('.hide')
        .not('.selected')
        .length;

    const $remaining = $swatchesWrapper.find('li.remaining-count');
    if ($remaining.length) {
        if (hiddenCount > 0) {
            $remaining.removeClass('hide').text(`+${hiddenCount}`);
        } else {
            $remaining.addClass('hide');
        }
    }
}

function hideOverflowingList() {
    if(!$('.pt_product-details').length) return;
     
	$('#product-content .pdp-vars').each(function () {
		const $container = $(this);

		let selectedValue = localStorage.getItem('selColorCat');
		let $filter;

		if (selectedValue) {
			// Try matching saved value
			$filter = $container.find('.color-filter-attr').filter(function () {
				return $(this).text().trim() === selectedValue;
			});
		}

		// Fallback to default ("All")
		if (!$filter || !$filter.length) {
			$filter = $container.find('.color-filter-attr.default');
			selectedValue = $filter.text().trim();
		}

		const selectedColor = $filter.data('color');
		handleColorSwatches($container, selectedValue, selectedColor);
	});
}

function initUndertoneFiltersEvents() {
    $(document).on('change', '.shade-filter-dropdown, .undertone-filter-dropdown', function () {
        const variationContainer = $(this).closest('.product-variations');
        const productSwatchesContainer = variationContainer.find('.product-variation-swatch-lists');
        const $swatchesWrapper = productSwatchesContainer.find('#pdp-swatches.swatches.color');
        const $swatches = $swatchesWrapper.find('li').not('.remaining-count');

        const selectedShade = $('.shade-filter-dropdown').length ? $('.shade-filter-dropdown').val() : 'all';
        const selectedUndertone = $('.undertone-filter-dropdown').length ? $('.undertone-filter-dropdown').val() : 'all';

        $swatches.show().removeClass('hide');

        let $filteredSwatches = $swatches;

        if (selectedShade !== 'all') {
            $filteredSwatches = $filteredSwatches.filter(function () {
                const curVal = ($(this).data('ccatvalues') || '').split(', ');
                return curVal.includes(selectedShade);
            });
        }

        if (selectedUndertone !== 'all') {
            $filteredSwatches = $filteredSwatches.filter(function () {
                const curVal = ($(this).data('undertonevalues') || '').split(', ');
                return curVal.includes(selectedUndertone);
            });
        }

        $swatches.not($filteredSwatches).hide().addClass('hide');
        $filteredSwatches.show().removeClass('hide');

        autoSelectFirstVisibleSwatch($swatchesWrapper, $swatches);
        applySwatchOverflow($swatchesWrapper, $swatches);

        if ($('.shade-filter-dropdown').length) {
            localStorage.setItem('selectedShadeTab', selectedShade);
        }
        if ($('.undertone-filter-dropdown').length) {
            localStorage.setItem('selectedUndertoneTab', selectedUndertone);
        }

        if (selectedShade === 'all' && selectedUndertone === 'all') {
            localStorage.removeItem('selectedShadeTab');
            localStorage.removeItem('selectedUndertoneTab');
        }
    });
}

function initShadeUndertoneFilters() {
    const selectedShadeTab = localStorage.getItem('selectedShadeTab');
    const selectedUndertoneTab = localStorage.getItem('selectedUndertoneTab');

    let hasChanged = false;

    if (selectedShadeTab && $('.shade-filter-dropdown').length) {
        $('.shade-filter-dropdown').val(selectedShadeTab);
        hasChanged = true;
    }

    if (selectedUndertoneTab && $('.undertone-filter-dropdown').length) {
        $('.undertone-filter-dropdown').val(selectedUndertoneTab);
        hasChanged = true;
    }

    if (hasChanged) {
        setTimeout(() => {
            $('.shade-filter-dropdown').trigger('change');
        }, 200);
    }
}

function initColorCategoryFilter() {
	var selectedColorCat = localStorage.getItem('selColorCat');
	if (selectedColorCat) {
		var prevSelectedFilter = $(".product-variation-swatch-lists li.color-filter-attr:contains('" + selectedColorCat +"')");
        
        if (prevSelectedFilter.length && prevSelectedFilter.length > 1) {
			prevSelectedFilter.each((id, elem) => {	
				let innerDomText = 	elem.innerText;
                
				if (innerDomText.toUpperCase() === selectedColorCat.toUpperCase()) { 
					
					elem.click();
					return;
				} 
			  }); 
		}
	}
}

function isOverflowColorShade($wrapper) {
    const $tiles = $wrapper.find('li.color-filter-attr');
    let totalWidth = 0;

    if ($wrapper.length && $tiles.length) {
        $tiles.each(function () {
            totalWidth += $(this).outerWidth(true); // include margin
        });
        return $wrapper.width() <= totalWidth;
    }
    return false;
}

function initColorShadesSlider() {

    $('.pdp-color-category-filter').each(function () {

        const $colorCategory = $(this);

        // Skip if already initialized
        if ($colorCategory.hasClass('slick-initialized')) return;

        if (isOverflowColorShade($colorCategory)) {
            $colorCategory.on('init', function (event, slick) {
                if (!slick || !slick.$slides) return; // check if slick exists
                $colorCategory.find('.slick-active').attr('tabindex', '0');
                $colorCategory.find('.slick-arrow').attr('tabindex', '0');
            });

            $colorCategory.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 2,
                centerMode: false,
                variableWidth: true,
                accessibility: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: false,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: false,
                            centerMode: false
                        }
                    }
                ]
            }).on('afterChange', function() {
            $colorCategory.find('.slick-slide').attr('tabindex', '0'); // remove all
            $colorCategory.find('.slick-active').attr('tabindex', '0'); // only active slides
        });
        }
    });
}

// initialize cross sell on click of swatches
function initMiniCrossSellPDP() {
	if($(".mini-cross-sell-wrapper").length) {
		miniCrossSell.init();
	}
}

function initReassuranceCarousel() {
    const $slideLength = $(".reassurance-content-wrapper .reassurance-item").length;
    if($slideLength > 1) {
        reassurance.init();
    }
}
/**
 * Updates the pricing display for a product set based on individual product prices,
 * optional custom bundle pricing, and current quantity.
 *
 * - Calculates total standard and sale prices from all products in the set.
 * - Applies custom bundle pricing if available and valid.
 * - Updates the DOM with the correct price (standard, sale, or custom).
 * - Adjusts Klarna payment widget with the latest purchase amount.
 * - Re-initializes UI components affected by price updates.
 * - Optionally executes a callback function after updating (e.g., availability check).
 *
 * @param {Function} [availability] - Optional callback function executed after price updates.
 */
function updateProductSetPrices(availability) {

    let standardPrice = 0;
    let salePrice  = 0;

    let customPrice = Number($('#setcustombundleprice').val()) || 0;
    let qty = $('.product-form-actions').find('select[name="Quantity"]').val();
    if (qty != null && qty !== '') {
        customPrice = Number((customPrice * qty).toFixed(2));
    }
    
    const productPriceArr = formatPidDataFromEles($('.product-set-list').find('form'));
    productPriceArr.forEach(function(item) {
        salePrice += Number(item.salePrice) || 0;
        standardPrice += Number(item.standardPrice) || 0;
    });

    salePrice = Number(salePrice);
    standardPrice = Number(standardPrice);

    const currencySymbol = window.User.currencyCode === "GBP" ? '£' : '€';
    const format = (price) => `${currencySymbol}${price}`;

    const hasCustom = customPrice > 0 && customPrice < standardPrice;
    const hasSale = salePrice > 0 && salePrice < standardPrice;
    const $btnElement = $("#add-all-to-cart");
    if (hasCustom) {
        // custom bundle is the discounted price
        $('.product-info #products-price span[itemprop="price"]').html(format(customPrice.toFixed(2)));
        $btnElement.find('.price-standard').text(format(standardPrice.toFixed(2)));
        $btnElement.find('.salesprice').text(format(customPrice.toFixed(2)));
    } else if (hasSale) {
        // normal sale
        $('.product-info #products-price span[itemprop="price"]').html(format(salePrice.toFixed(2)));
        $btnElement.find('.price-standard').text(format(standardPrice.toFixed(2)));
        $btnElement.find('.salesprice').text(format(salePrice.toFixed(2)));
    } else {
        // standard only
        $('.product-info #products-price span[itemprop="price"]').html(format(standardPrice.toFixed(2)));
        $btnElement.find('.standardprice, .price-standard').text(format(standardPrice.toFixed(2)));
    }
    
    setBVSummaryPosition();
    customDropdown.init();
    checkoutReinsurancePopup();
    $(document).foundation();

    //klarna OSM product set update
    var amount = salePrice;
    amount =  amount.toString();
    amount = amount.replace(/\./g, "");
    // document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", amount);
    $( ".product-set-actions" ).find( "klarna-placement" ).attr("data-purchase-amount", amount);
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [] // Making sure that data layer exists in case the On-Site JavaScript library is loaded later for any reason
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' }) // Push the event to the data layer

    // Callback after content update
    if (typeof availability === 'function') {
        availability();
    }
}

function getProductNameWithoutSpace() {
	return $("h1#products-name").html().trim();;
}

export default function () {

    var $pdpMain = $('#pdpMain, .crosssell-recommendation-modal #pdpMain');
    let shadePanelTrigger = null;
	let shadePanelTriggerSelector = null;
	let isShadePanelFocusTrapActive = false;
    localStorage.removeItem('selColorCat');
    localStorage.removeItem('selectedShadeTab');
    localStorage.removeItem('selectedUndertoneTab');
    setCategoryItem();
    var selectedColor = $('.variation-select').find(':selected').data('color');
    $('.swatch-block.selected_color').attr('style',selectedColor);    

	function restoreShadePanelFocus() {
		let $trigger = $(shadePanelTrigger);

		if (!$trigger.length || !document.body.contains($trigger[0])) {
			$trigger = $(shadePanelTriggerSelector).first();
		}

		if ($trigger.length) {
			$trigger.focus();
		}
		shadePanelTrigger = null;
		shadePanelTriggerSelector = null;
	}

    function closeShadePanel(shouldRestoreFocus) {
		const $shadePanel = $('.product-shade-panel');

		$('#product-shade-panel-status').text($shadePanel.data('closed-message'));
		$('.sticky-component').removeClass('hidden');
		$shadePanel.removeClass('opened');
		$('html').removeClass('modal-open');
		$shadePanel.find('.custom-dd-list-item').removeClass('productshadelastelement');

		if (isShadePanelFocusTrapActive) {
			accessibility.setKeepFocusInside(document.querySelector('#product-shade-panel'), false);
			isShadePanelFocusTrapActive = false;
		}
		$shadePanel.attr('aria-hidden', 'true').attr('inert', '');

		if (shouldRestoreFocus !== false) {
			restoreShadePanelFocus();
		}
	}

    $pdpMain.on('click keydown', '#product-content .swatchanchor', function (e) {

        // Allow click OR Enter key
		if (e.type === 'keydown' && e.key !== 'Enter') {
			return;
		}

        e.preventDefault();
        e.stopImmediatePropagation();

        var $this = $(this);
        if( $this.hasClass('viewall') ){
            window.location.href = this.href ;
        } else {
            var isMiniQuickView = $this.closest(".product-tile").length > 0;
            var targetContainer = null;

            if ($this.parents('.quickview-mini-modal').length > 0) {
                isMiniQuickView = true;
                targetContainer = '.quickview-mini-modal #product-content';
            }
            
            if(isMiniQuickView) {
                updateMiniQuickViewContent(this.href, targetContainer);
            } else {
            	//cart edit overlay
            	var isCartOverlay = false;
            	if($(this).parents(".edit-modal.quickview-modal").length > 0){
            		this.href = this.href+"&itemFrom=edit";
            		isCartOverlay = true;
            	}
            	
            	var urlLink = this.href;
            	
            	//PDP variant updation
                if($(this).closest(".content-pdp").length > 0){//PDP Specific
        	    	urlLink = Urls.productVariationDetails+"?pid="+$(this).attr("data-mpid")+"&"+$(this).attr("data-varianttype")+"="+$(this).attr("data-variantval")+"&Quantity=1&format=ajax";
                    var guid = $(this).attr('data-guid');
        	    }

                var clickedVariantId = $(this).attr('data-variantid');
                var restoreSwatchFocus = function () {
                    var $newSwatch = $('#product-content .swatchanchor[data-variantid="' + clickedVariantId + '"]').closest('li');
                    if ($newSwatch.length) {
                        $newSwatch.focus();
                    }
                };
                
                if(urlLink){
                    if ($('#immersive_experience').length > 0) {
                        if(window.YMK && window.YMK.open && $('.vto-iframe-opened').length > 0) {
                            window.YMK.open(true);
                        } 

                        urlLink = urlLink + '&immersiveExperience=true';
                    };
                    
                	updateContent(urlLink,guid,restoreSwatchFocus);
                }
                if(!window.checkCategoryClicked) {
                    window.dataLayer.push(util.filterObj({
                        "event": "productInteraction",
                        "productName": getProductNameWithoutSpace(),
                        "productId": $(this).attr("data-variantid"),
                        "interactionType" : "select_shade_selector"
                    }));
                } else {
                    window.checkCategoryClicked = false;
                }
                

                //NAB-4942 GTM productvariation ID update logic
                $(document).ajaxComplete(function(){
                    if (!$('#pdp-swatches').hasClass('populate-gtm')) {
                        $('#pdp-swatches').addClass('populate-gtm')
                        var data = $('#pdp-swatches .populate-gtm');
                        if(!isCartOverlay){//skip for cart overlay, productCache undefined                        	
                        	$('body').trigger('update-gtm', data);
                    	}
                        
                    }
                });
            }
        }
    }).on('click', '.regimenzone .variation-select', function (e) {
    	 e.preventDefault();
    	 
    }).on('click keydown', '#product-content .custom-dd .custom-dd-list-item', function (e) {  //  change variation based on custom dropdown selection	
    	// Trigger only on click OR Enter key
		if (e.type === 'keydown' && e.key !== 'Enter') {
			return;
		}
    
        if($("#product-content").find(".content-pdp").length > 0){//PDP Specific
			var swatch =  $('ul.product-variation-swatch-lists').find('#pdp-swatches .swatchanchor:has(img[alt="' + $(this).data("value") +'"])');
			 var href = Urls.productVariationDetails+"?pid="+$(swatch).attr("data-mpid")+"&"+$(swatch).attr("data-varianttype")+"="+$(swatch).attr("data-variantval")+"&Quantity=1&format=ajax";
             var guid = $(swatch).attr('data-guid');

	    }else{
	    	var img = $('ul.product-variation-swatch-lists').find('#pdp-swatches .swatchanchor:has(img[alt="' + $(this).data("value") +'"])');
	        var href = img.closest('a').attr('href');
            var guid = $(swatch).attr('data-guid');

	    }
        
        // don't change if selected variant clicked			
		if ($(this).hasClass('selected') || $(this).data("value") === '') {
			return;
		}

        if ($('#immersive_experience').length > 0) {//override for immersive
            href = href + '&immersiveExperience=true';
        };
        localStorage.setItem("selColorCat", $(".product-shade-panel").find(".color-filter-attr.selected").attr('data-color'));
        if($('#shade-filter-dropdown').length > 0){ 
            const selectedShade = $(".product-shade-panel").find(".color-filter-attr.selected").attr('data-color');
            
            localStorage.setItem("selectedShadeTab", selectedShade == "default" ? "all" : selectedShade);
        }
        
        closeShadePanel(false);
        window.dataLayer.push(util.filterObj({
            "event": "productInteraction",
            "productName": getProductNameWithoutSpace(),
            "productId": $(swatch).attr("data-variantid"),
            "interactionType" : "select_shade_selector"
        }));
        updateContent(href,guid, restoreShadePanelFocus);
        
    }).on('click', '.regimenzone .custom-dd-list-item', function () {  //  change variation based on custom dropdown selection regimenzone
    	
    	if($(this).closest(".custom-dd").length > 0){ // regimenzone Specific
			 var href = Urls.productVariationDetails+"?pid="+$(this).attr("data-mpid")+"&"+$(this).attr("data-varianttype")+"="+$(this).attr("data-variantval")+"&Quantity=1&format=ajax";
	    }else{
	        var href = $(this).closest('a').attr('href');
	    }
        // don't change if selected variant clicked			
		if ($(this).hasClass('selected') || $(this).data("value") === '') {
			return;
		}
         
        updateContentRegimen($(this),href);
        
    }).on('change', '#product-content #products-info .variation-select, .regimenzone .variation-select', function () {    	
        var img = $('ul.product-variation-swatch-lists').find('#pdp-swatches .swatchanchor:has(img[alt="' + $(this).val() +'"])');
        var href = img.closest('a').attr('href');

        var $selectedVariantOption = $(this).find("option:selected");
        if($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
            return;
        }
        
        if($(this).parents(".regimenzone").length > 0){
            var href = $selectedVariantOption.data("changeurl");
        	updateContentRegimen($(this),href);
        }else{
            updateContent(href);
        }
        
    }).on('click', '#product-content #products-info .variation-select', function () {
        if(util.isMobile()){
            var currentObj = $(this).closest('.product-info').find('.product-variation-swatch-lists');
            var parentPersistance = $(this).closest('.price-qty-row');
            if (!$(parentPersistance).hasClass('active')){
                $(parentPersistance).addClass('active');
                currentObj.show();
            } else {
                $(parentPersistance).removeClass('active');
                currentObj.hide();
            }
        }
    }).on('click keydown', '.remaining-count, .custom-dd-disabled .custom-dd-list-item-selected', function (e) { 
        if (e.type === 'keydown' && e.key !== 'Enter') return;

        // remember trigger so focus can return to it when the panel closes
        shadePanelTrigger = this;
        shadePanelTriggerSelector = $(this).hasClass('remaining-count')
            ? '#product-content .remaining-count'
            : '#product-content #' + $(this).closest('.custom-dd').attr('id') + ' .custom-dd-list-item-selected';

        const isTablet = window.matchMedia('(max-width: 768px)').matches;
        const windowWidth = $(window).width();

        const $shadePanel = $('.product-shade-panel');
        const $panelWrapper = $shadePanel.find('.panel-wrapper');
        const $listItems = $shadePanel.find('.custom-dd-list-item');

        const selectedColor = $('#product-content')
            .find('.color-filter-attr.selected')
            .first()
            .data('color');

        $panelWrapper.css('width', isTablet ? windowWidth : '');

        if (selectedColor) {
            $shadePanel
                .find(`.color-filter-attr[data-color="${selectedColor}"]`)
                .trigger('click');
        }

        if ($('.pt_product-details').hasClass('sticky-header')) {
            $('.sticky-component').addClass('hidden');
        }

        $shadePanel.removeAttr('style inert').attr('aria-hidden', 'false').addClass('opened');
        $('html').addClass('modal-open');

        // Move focus into the panel (close icon) before announcing the opened status,
		// so screen readers announce the close button context rather than being interrupted
		accessibility.setKeepFocusInside(document.querySelector('#product-shade-panel'), true);
		isShadePanelFocusTrapActive = true;
		// last item in the panel gets the focus-trap marker; OOS shades stay in tab order
		$listItems.last().addClass('productshadelastelement');
		requestAnimationFrame(function () {
			$shadePanel.find('.icon-close').focus();
			$('#product-shade-panel-status').text($shadePanel.data('opened-message'));
		});

	}).on('click keydown', '.product-shade-panel .icon-close, .product-shade-panel .panel-overlay', function (e) { 
		if (e.type === 'keydown' && e.key !== 'Enter') return;

        closeShadePanel();

	}).on('keydown', '.product-shade-panel', function (e) { 
        if (e.key === 'Escape') {
            e.preventDefault();
			closeShadePanel();
        }
	});

    $(document).on('click', '.regimenzone .custom-dd-list-item-selected, .regimenzone .custom-dd-list-item ', function(e){
        e.preventDefault();
        e.stopPropagation();
    }).on('keydown', function(e){
        
        if (!$('.product-shade-panel').hasClass('opened')) {
			return;
		}

    });

    $pdpMain.on('click', '#product-set .swatchanchor', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
         updateSetContent($(this), $(this).attr("href"), checkAvailability);
    }).on('click', '#product-set .custom-dd .custom-dd-list-item', function () {
    	
        var img = $(this).parents(".dropdown-wrapper").find('ul.product-variation-swatch-lists').find('#pdp-swatches .swatchanchor:has(img[alt="' + $(this).data("value") +'"])');
        var href = img.closest('a').attr('href');
        
        // don't change if selected variant clicked			
		if ($(this).hasClass('selected') || $(this).data("value") === '') {
			return;
		}

        updateSetContent($(this), href, checkAvailability);
    });

    $(".pt_product-details").on("change","#product-set #quantity",function(e) {
        // bundle product quantity change
        if($('.productset-container').length > 0 ) {
            updateProductSetPrices(checkAvailability);
        }
    });

    notifyOnWhatsapp();
    
    variationfilter();
    regimenVariationfilter();
    setBVSummaryPosition();
    screenResizeHandler();
    customDropdown.init();
    initFindation();
    resizeStickySidebar();
    initColorCatFiltersEvents();
    initUndertoneFiltersEvents();
    initColorCategoryFilter();
    initShadeUndertoneFilters();
    initColorShadesSlider();
    initMiniCrossSellPDP();
    initReassuranceCarousel();
    addMinHeightToPdpImage();
    displayPDPImage();
    hideOverflowingList();
    $('.regimen-product-column').find('.custom-dd-list-item-selected .oos-label').length > 0 ? $(' .regimenzone.add-all').attr('disabled', 'disabled') : $('.regimenzone.add-all').removeAttr('disabled');

    
    $(window).on('resize orientationchange', function () {
		resizeStickySidebar();
        setVTOIframePosition();
        hideOverflowingList();

        //To fix issues related to VTO module on resize
        if(screen.width < 480){
            $('#YMK-module-iframe').css('width',screen.width);
            $('div[role=document]').css('width','100%');
            $('#result-canvas').find('#canvas').css('width',screen.width);
        } else {
            $('#YMK-module-iframe').css('width','450px');
            $('div[role=document]').css('width','100%');
        }
	});

    // VTO plugin events binding
    $(document).on('click', '.shader-finder-cta.vto-cta', function(e){
        e.preventDefault;
        if(window.YMK) {
            window.YMK.open(true);
            setVTOIframePosition();
        } 
    });    
    window.YMK && window.YMK.addEventListener('opened', function() {
        asyncSetVtoIframePosition(1000);
    });
    
   var lastScrollTop = 0;
    $(window).on('scroll', function() {
        if(window.YMK && window.YMK.isLoaded()){
            setVTOIframePosition();
        }
        var st = $(this).scrollTop();
        if (st < lastScrollTop && window.YMK && window.YMK.isLoaded()){
            // upscroll code
            st === 0 && asyncSetVtoIframePosition(500);
        } 
        lastScrollTop = st;
    });

    $('.pt_product-details .pdp-main').length && util.setCompareAttributesEqualHeight('.product-compare-attributes', '.compare-attributes-item');
};